module.exports = __webpack_public_path__ + "img/MRC.d047cd25.svg";